<script setup>
import { REPLY_EDITOR_MODES } from './constants';

const props = defineProps({
  mode: {
    type: String,
    default: REPLY_EDITOR_MODES.REPLY,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isReplyRestricted: {
    type: Boolean,
    default: false,
  },
  showSuggestion: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['changeMode']);

const selectMode = mode => {
  if (
    props.disabled ||
    (props.isReplyRestricted && mode !== REPLY_EDITOR_MODES.NOTE)
  )
    return;
  emit('changeMode', mode);
};

const buttonClass = mode => ({
  'bg-n-brand/10 text-n-brand ring-1 ring-n-brand/40': props.mode === mode,
  'text-n-slate-11 hover:text-n-slate-12': props.mode !== mode,
});
</script>

<template>
  <div
    class="flex items-center w-auto h-8 p-1 rounded-lg bg-n-alpha-2"
    role="tablist"
  >
    <button
      type="button"
      class="inline-flex h-6 items-center gap-1 px-2 text-sm rounded-lg transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      :class="buttonClass(REPLY_EDITOR_MODES.REPLY)"
      :disabled="disabled || isReplyRestricted"
      role="tab"
      :aria-selected="mode === REPLY_EDITOR_MODES.REPLY"
      @click="selectMode(REPLY_EDITOR_MODES.REPLY)"
    >
      <span class="i-lucide-reply size-3.5" />
      {{ $t('CONVERSATION.REPLYBOX.REPLY') }}
    </button>
    <button
      type="button"
      class="inline-flex h-6 items-center gap-1 px-2 text-sm rounded-lg transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      :class="buttonClass(REPLY_EDITOR_MODES.NOTE)"
      :disabled="disabled"
      role="tab"
      :aria-selected="mode === REPLY_EDITOR_MODES.NOTE"
      @click="selectMode(REPLY_EDITOR_MODES.NOTE)"
    >
      <span class="i-lucide-lock-keyhole size-3.5" />
      {{ $t('CONVERSATION.REPLYBOX.PRIVATE_NOTE') }}
    </button>
    <button
      v-if="showSuggestion"
      type="button"
      class="inline-flex h-6 items-center gap-1 px-2 text-sm rounded-lg transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-n-brand"
      :class="buttonClass(REPLY_EDITOR_MODES.SUGGESTION)"
      :disabled="disabled || isReplyRestricted"
      role="tab"
      :aria-selected="mode === REPLY_EDITOR_MODES.SUGGESTION"
      @click="selectMode(REPLY_EDITOR_MODES.SUGGESTION)"
    >
      <span class="i-lucide-message-circle size-3.5" />
      {{ $t('CONVERSATION.REPLYBOX.CORTEX_CHAT.TITLE') }}
    </button>
  </div>
</template>
